// extracted by mini-css-extract-plugin
module.exports = {"headingStyle":"QuickTour_headingStyle__b867I","FooterQ":"QuickTour_FooterQ__2rviB"};